import "./HeaderMenuInjector.css";
import React, { FC, useState } from "react";
import { Link } from "gatsby";
import {
  Container,
  Dropdown,
  Header,
  Icon,
  Image,
  Menu,
  Sidebar,
} from "semantic-ui-react";

export const HeaderMenuInjector: FC = ({ children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Sidebar.Pushable>
        <Sidebar
          as={Menu}
          animation="overlay"
          onHide={() => setVisible(false)}
          vertical
          borderless
          visible={visible}
          // メニュー選択したら閉じたいので
          onClick={() => setVisible(false)}
        >
          {/*
           * --- モバイル用メニュー ---
           */}
          <Menu.Item header>プロダクト</Menu.Item>
          <Menu.Item as={Link} to="/products/cubifox">
            🦊 CUBIFOX
          </Menu.Item>
          <Menu.Item as={Link} to="/products/dddog">
            🐶 DDDOG
          </Menu.Item>
          <Menu.Item as={Link} to="/products/nft_login">
            🗝 NFT Login
          </Menu.Item>
          <Menu.Item as={Link} to="/products/hamster_run">
            🐹 Hamster Run
          </Menu.Item>
          <Menu.Item as={Link} to="/products/share_ninja">
            🥷 Share Ninja
          </Menu.Item>
          <Menu.Item header>会社情報</Menu.Item>
          <Menu.Item as={Link} to="/about">
            Clarity Solutionsについて
          </Menu.Item>
          <Menu.Item as={Link} to="/contact">
            お問い合わせ
          </Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={visible}>
          <Menu borderless>
            <Container>
              {/*
               * --- モバイル用メニューを表示するボタン ---
               */}
              <Menu.Item
                className="HeaderMenuInjector-mobile"
                onClick={() => setVisible(true)}
              >
                <Icon name="bars" />
              </Menu.Item>

              {/*
               * ロゴ
               */}
              <Menu.Item as={Link} to="/">
                <Image
                  size="medium"
                  src="/assets/logo.png"
                  style={{ paddingRight: "3em" }}
                />
              </Menu.Item>

              {/*
               * --- PC用メニュー ---
               */}

              <Menu.Item
                position="right"
                as={Link}
                to="/about"
                className="HeaderMenuInjector-pc"
              >
                Clarity Solutionsについて
              </Menu.Item>

              <Dropdown
                item
                text="プロダクト"
                className="HeaderMenuInjector-pc"
              >
                <Dropdown.Menu>
                  <Dropdown.Header>
                    <Header as={Link} to="/products/cubifox">
                      🦊 CUBIFOX
                    </Header>
                  </Dropdown.Header>
                  <Dropdown.Divider />
                  <Dropdown.Header>
                    <Header as={Link} to="/products/dddog">
                      🐶 DDDOG
                    </Header>
                  </Dropdown.Header>
                  <Dropdown.Divider />
                  <Dropdown.Header>
                    <Header as={Link} to="/products/nft_login">
                      🗝 NFT Login
                    </Header>
                  </Dropdown.Header>
                  <Dropdown.Divider />
                  <Dropdown.Header>
                    <Header as={Link} to="/products/hamster_run">
                      🐹 Hamster Run
                    </Header>
                  </Dropdown.Header>
                  <Dropdown.Divider />
                  <Dropdown.Header>
                    <Header as={Link} to="/products/share_ninja">
                      🥷 Share Ninja
                    </Header>
                  </Dropdown.Header>
                  <Dropdown.Divider />
                </Dropdown.Menu>
              </Dropdown>

              <Menu.Item
                as={Link}
                to="/contact"
                className="HeaderMenuInjector-pc"
              >
                お問い合わせ
              </Menu.Item>
            </Container>
          </Menu>

          {children}
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </>
  );
};
